import React from "react";
import cn from "classnames";
import { Link } from "components/LanguageChanger"; // this is your LocalizedLink

import "./ServiceItem.scss";

interface ServiceItemProps {
  title: string;
  icon?: React.ReactNode;
  className?: string;
  onlyText?: boolean;
  onClick?: () => void;
  href?: string; // Route path like "/services/123"
}

export const ServiceItem = ({
  title,
  icon,
  className,
  onClick,
  onlyText,
  href,
}: ServiceItemProps) => {
  const Wrapper: any = href ? Link : "div";

  return (
    <Wrapper
      {...(href ? { to: href } : { onClick })}
      className={cn(className, "service-item")}
    >
      {!onlyText && <div className="service-item__icon">{icon}</div>}
      <div className="service-item__title">{title}</div>
    </Wrapper>
  );
};
